import { AttachmentPayload } from "./Types";

export const ModelsCompany = [
  "OpenAI",
  "Google",
  "HuggingFace",
  "Anthropic",
  "Meta",
  "MistralAi",
  "Nvidia",
  "Alibaba",
  "Microsoft",
  "DeepSeek",
];

export const ModelImageFXName = "Imagin-3";
export const GptImageVersion = "gpt-image-1";
export const ModelImageFXModelName = "ImageFX";
export const ModelWhiskModelName = "Whisk";
export const ModelImageFluxName = "Flux";
export const ModelImageStabilityName = "Stability";
export const ModelImageDall_EName = "Dall-E";
export const ModelImageGptImageName = "Sora";
export const ModelImageGrokName = "Grok";

export const ModelsNamesCompany: any = {
  chatgpt: "OpenAI",
  gemini: "Google",
  huggingface: "HuggingFace",
  anthropic: "Anthropic",
  llama: "Meta",
  mistralai: "MistralAi",
  nvidia: "Nvidia",
  alibaba: "Alibaba",
  microsoft: "Microsoft",
  deepseek: "DeepSeek",
};

export const modelNames = [
  "ChatGPT",
  "Gemini",
  "HuggingFace",
  "Anthropic",
  "Llama",
  "MistralAi",
  "Nvidia",
  "Alibaba",
  "Microsoft",
  "DeepSeek",
];
// model settings parameter
export interface ParameterTypes {
  temperature: number;
  temperatureCurrentValue: number;
  temperatureMaxValue: number;
  temperatureMinValue: number;
  maxToken: number;
  maxTokenCurrentValue: number;
  maxTokenMaxValue: number;
  maxTokenMinValue: number;
  topP: number;
  topPCurrentValue: number;
  topPMaxValue: number;
  topPMinValue: number;
  frequency: number;
  frequencyCurrentValue: number;
  frequencyMaxValue: number;
  frequencyMinValue: number;
  presencePenalty: number;
  presencePenaltyCurrentValue: number;
  presencePenaltyMaxValue: number;
  presencePenaltyMinValue: number;
}
// Email Validation
export const emailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// Password validation
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;

// Change password & Reset password validation
export const changePasswordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;
export interface FilterItem {
  title: string;
  value: string;
}
//firstName and lastName validation
export const nameRegex = /^[A-Za-z]+$/;
export interface dataReplyType {
  createdAt: string;
  reply: string;
  attachment?: string;
}

export interface ChatModelState {
  id: string;
  parentId: string | null;
  prompt: string;
  replies: dataReplyType[];
  isRegernating: boolean;
  isEditing: boolean;
  queryAttachments: AttachmentPayload[];
  version: string;
  createdAt?: string;
  activeReplyIndex?: number;
  queryEdits?: string[];
  messageType: number;
  modelName: string;
}

export interface ChatModelEditsState {
  MessageId: string;
  EditMessageIndex: any;
  ResponseIndex: any;
}

export interface ModelVersionStatus {
  version: string;
  isFinished: boolean;
}
export interface StopModelsRequestParams {
  connectionId: string | null;
  param: Record<string, boolean> | Record<string, boolean>[];
}
export interface DescAndObjPersonaType {
  personaTitle: string;
  connectionId: string;
}
// handle BG of user name if there is no user image
export const stringToHslColor = (str: string, s: number, l: number) => {
  var hash = 0;
  for (var i = 0; i < str?.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  var h = hash % 360;
  return "hsl(" + h + ", " + s + "%, " + l + "%)";
};

export interface PersonaItemData {
  id: string | null;
  title: string | null;
  description: string | undefined;
  objective: string | null;
}

export interface iconProps {
  className: string;
  source?: string;
  size?: string;
}

export interface DefaultModelMode {
  mode: number;
  modeAccessibility: number;
  isDefault: boolean | null;
  chat1Name: string | null;
  chat2Name: string | null;
  chat3Name: string | null;
  chat4Name: string | null;
  chat5Name: string | null;
  chat6Name: string | null;
}

export interface HealthCheckModel {
  modelName: string | null;
  versionName: string | null;
  status: string | null;
  errors: string | null;
}

export const ConversationName = "New chat";
export const TouchToleranceX = 50;
export const TouchToleranceY = 30;

export enum ModeAccessibility {
  Anonymous = 1,
  Authenticated,
  Subscribed,
}

// enum to get default models number.
export enum DefaultModelsNumber {
  Mode0 = 1,
  Mode1 = 2,
  Mode2 = 4,
  Mode3 = 6,
}

export const freeFeatures = [
  "Chat with 4 AI models.",
  "Unlimited history access.",
  "Full access to text suite.",
  "Limited Access to Prompt Library (Basic prompts).",
  "Using only persona of the system.",
];

export const proFeatures = [
  "Unlimited chats with 6 AI models.",
  "Unlimited history access.",
  "Full access to text, image, and video suites.",
  "Advanced workflow automation and creation (unlimited).",
  "Access to Prompt Library (Extensive prompts).",
  "Full control over model settings.",
  "Creation unlimited number to personas.",
  "Early access to new features.",
];

export interface ValidationRule {
  error: boolean;
  message: string;
}

export interface PasswordValidations {
  minimumLength: ValidationRule;
  includesDigit: ValidationRule;
  lowercaseRequired: ValidationRule;
  uppercaseRequired: ValidationRule;
  specialCharacter: ValidationRule;
}

export const TranslatePromptLanguage = [
  "English",
  "English (Gen Z slang)",
  "Arabic",
  "Arabic (Egyptian slang)",
  "Arabic (Saudi slang)",
  "Arabic (UAE slang)",
  "Chinese (Simplified)",
  "French",
  "Spanish",
  "German",
  "Hindi",
  "Russian",
  "Portuguese",
  "Italian",
  "Japanese",
  "Korean",
  "Polish",
  "Swedish",
  "Turkish",
  "Norwegian",
  "Danish",
  "Finnish",
  "Bengali",
  "Indonesian",
  "Persian",
  "Hebrew",
  "Thai",
];

export const OutputPromptLanguages = [
  "English",
  "Arabic",
  "Chinese (Simplified)",
  "French",
  "Spanish",
  "German",
  "Hindi",
  "Russian",
  "Portuguese",
  "Italian",
  "Japanese",
  "Korean",
  "Polish",
  "Swedish",
  "Turkish",
  "Norwegian",
  "Danish",
  "Finnish",
  "Bengali",
  "Indonesian",
  "Persian",
  "Hebrew",
  "Thai",
];
export const FinishMark = "**/**Finished**/**";

export enum MessageType {
   NewMessage = 1,
 Regenerate,
 Edit,
 Raname,
 Enhance,
 Translate,
 GeneratePersonaDescription,
 GeneratePersonaObjective,
 Utility,
 GenerateImage,
 MessageHasImage,
 TextSuiteTranslate,
 TextSuiteHumanize,
 TextSuiteSummarize,
 TextSuiteParaPhrase,
 TextSuiteAIDetector,
 TextSuiteTitleGenerator,
 TextSuitePromptEngineer,
 TextSuiteWorkflow,
 ImageSuiteGenerateImage,
 ImageSuiteGenerateLogo,
 ImageSuiteGenerateIcon,
 ImageSuiteGenerateIllustration,
 ImageSuiteBackgroundRemover,
 ImageSuiteHeadshotGenerator,
 ImageSuiteRestoreImage,
 TextSuiteExtraction,
 ImageSuitePhotoStudio,
 ImageSuiteTinyFigures,
 ImageSuiteMicroPeople,
 ImageSuiteImageToImage,
 TextSuiteImageToPrompt,
 ImageSuiteError,
 ImageSuiteWorkflow,
 WebSearch,
 SendAttachment, 
 VideoSuitesGenerateVideo,
 VideoSuitesImageToVideo,
 VideoSuitesCustomAvatar,
 VideoSuiteWorkflow,
}

export enum PersonaType {
  System = 1,
  User = 2,
}

export enum SubscriptionStatus {
  Trial = 0,
  Active,
  Cancelled,
}

export const TextSuitesApps = [
  {
    appTitle: "Translator",
    selectorTitle: "Detect language",
    sucSelectorTitle: "Select language",
    inputDesc: "Type or paste your text here to translate..",
    outputDesc: "The output will appear here...",
    btnActionTitle: "Translate",
    selectorOptions: ["Detect language", ...OutputPromptLanguages],
    defaultSelectorOption: "Detect language",
    loadingMsg: "Translating",
  },
  {
    appTitle: "Humanizer",
    selectorTitle: "Select style",
    inputDesc: "Type or paste your AI-generated text here....",
    outputDesc: "The output will appear here...",
    btnActionTitle: "Humanize",
    selectorOptions: ["General", "Academic", "Formal", "Informal", "Blog"],
    defaultSelectorOption: "General",
    loadingMsg: "Humanizing",
  },
  {
    appTitle: "Summarizer",
    selectorTitle: "Select mode",
    inputDesc: "Type or paste your text to summarize here....",
    outputDesc: "The output will appear here...",
    btnActionTitle: "Summarize",
    selectorOptions: ["Paragraph", "Bullet points"],
    defaultSelectorOption: "Paragraph",
    loadingMsg: "Summarizing",
  },
  {
    appTitle: "Paraphraser",
    selectorTitle: "Select mode",
    inputDesc: "Type or paste your text to rephrase here....",
    outputDesc: "The output will appear here...",
    btnActionTitle: "Rephrase",
    selectorOptions: ["Standard", "Formal", "Fluent", "Simple", "Academic"],
    defaultSelectorOption: "Standard",
    loadingMsg: "Paraphrasing",
  },
  {
    appTitle: "AI detector",
    inputDesc: "Type or paste your text here to analyze ....",
    outputDesc: "Add text to begin analysis",
    btnActionTitle: "Detect AI",
    defaultSelectorOption: "",
    loadingMsg: "Detecting",
  },
  {
    appTitle: "Title Generator",
    selectorTitle: "Select purpose",
    inputDesc: "Type or paste your text to rephrase here....",
    outputDesc: "The output will appear here...",
    btnActionTitle: "Generate title",
    selectorOptions: ["General", "Blog", "Book", "Slogan", "YouTube video"],
    sloganDesPlaceholder:
      "Describe your product, highlighting unique features and values..*Notice: Brief Description must be > 50 characters.",
    sloganCompanyName: "Expertex",
    youtubeDesPlaceholder:
      "Briefly describe your video. What is it about, and who is it for?*Notice: Brief Description must be > 50 characters.",
    youtubeKeysPlaceholder: "Yoga, Stress relief, Beginner tips",
    defaultSelectorOption: "General",
    loadingMsg: "Generating",
  },
  {
    appTitle: "Prompt Generator",
    inputDesc: "Type or paste your text here to generate a prompt..",
    outputDesc: "The output will appear here..",
    btnActionTitle: "Generate",
    defaultSelectorOption: "",
    loadingMsg: "Generating",
  },
];

export enum AppViewType {
  MainPage = 0,
  TextSuites,
  ImageSuites,
  VideoSuites,
}

export enum SummarizeOutputValues {
  Low = 100,
  Medium = 200,
  High = 400,
  VeryHigh = 800,
}

// Function to get the index of the key by value (starting from 1)
export const getSummarizeOutputKeyIndexByValue = (
  value: number
): number | undefined => {
  const keys = Object.keys(SummarizeOutputValues).filter((key) =>
    isNaN(Number(key))
  );

  const index = keys.findIndex(
    (key) =>
      SummarizeOutputValues[key as keyof typeof SummarizeOutputValues] === value
  );

  return index >= 0 ? index : undefined;
};

export const allowedExtensionsImage = ["jpg", "jpeg", "png", "webp"];
export const allowedExtensionsFile = ["doc", "docx", "xls", "xlsx", "pdf"];

export const DurationDropdownItems = ["Forever", "Once", "Multiple months"];
export const SubscriptionType = ["Monthly", "Yearly"];

export const PromotionDropdownItems = [
  "Life Time",
  "Percentage Off",
  "Flat Amount Off",
  // "Limited Time",
];

export enum PromotionType {
  LifeTime = 0,
  DiscountPercentage,
  DiscountFixedAmount,
  // LimitedTime,
}

export enum DurationType {
  Forever = 0,
  Once,
  Repeating,
}

export enum PromoCodeStatus {
  Expired = 0,
  Active,
}

export interface PromoAlertData {
  show: boolean;
  headerTitle: string;
  description: string;
  firstAction: string;
  secAction: string;
  alertType: string;
}

export interface PromoCodeData {
  promoCodeId: string;
  code: string;
  codeName: string;
  promotionType: number;
  promotionValue: number;
  subscriptionType: string;
  durationById: string;
  status: number;
  createdAT: string;
  lastUpdate: string;
  expireAt: string;
  description: string;
  createdBy: string;
  totalUses: number;
  used: number;
  imageUrl: string;
  unLimitedFlag: boolean;
}

export const CreateWorkflow = "createWorkflow";
export const CreateWorkflowPreview = "createWorkflowPreview";
export const TextSuites = "TextSuites";

export enum ImageSuiteType {
  ImageGenerator = 0,
  LogoGenerator,
  IconGenerator,
  IllustrationGenerator,
  BackGroundRemover,
  ImageRestore,
  MicroPeople,
  TinyFigures,
}

export enum TextSuiteType {
  Translator = 0,
  Humanizer,
  Summarizer,
  Paraphraser,
  TitleGenerator,
  PromptGenerator,
  TextExtraction,
  ImageToPrompt,
  ImageToImage,
}

export interface MetaData {
  before?: string;
  after?: string;
  ImageAfterInLight?: string;
}

export interface ImageSuiteSample {
  type: number;
  prompt?: string;
  path?: string;
  metaData?: string;
}
export interface TextSuiteSample {
  type: number;
  prompt?: string;
  path?: string;
  metaData?: string;
}

interface ImageSettingModelItem {
  modelVersion: string;
  modelName: string;
}

export interface ImageSettings {
  imageModels: ImageSettingModelItem[];
  imageDimensions: string[];
  seed: number | null;
}

export interface ImageSuiteExample {
  prompt: string | undefined;
  imageUrl: string | undefined;
}

export interface ImageSuiteAppProps {
  inputValue: any;
  example: ImageSuiteSample;
  imageSettings: ImageSettings;
  generatedImg: string;
  generatedPrompt: string;
  selectedModel: string | undefined;
  selectedSize: string | undefined;
  seed: number | null;
  openLockSeed: boolean;
  isGenerateImgLoading: boolean;
  IsGeneratePromptLoading: boolean;
  isGenerateButtonDisabled: boolean;
  setInputValue: (value: string) => void;
  toggleLockSeed: (flag: boolean) => void;
  handleOpenExpandImage: () => void;
  handelGenerateRandomPrompt: () => void;
  getErrorMessage: (error: any) => void;
  setSelectedSize: (size: string) => void;
  setSelectedModel: (model: string) => void;
  handleSetIsLoading: (isLoading: boolean) => void;
  inputImageValue?: any;
  handleClearInput?: () => void;
  handleInputImageChange?: (image: File |string| null) => void;
  handelImprovePrompt?: () => void;
  isImagePromptImproving?: boolean;
  creditsNeeded: number | null;
}

export enum ImageSuitApps {
  ImageGenerator = 0,
  LogoGenerator,
  IconGenerator,
  IllustrationGenerator,
  BackGroundRemover,
  ImageRestore,
  MicroPeople,
  TinyFigures,
  ImageToImage,
}

export interface ImageSuiteAppInterface {
  input: any;
  generatedImg: string;
  selectedModel?: string;
  imageSettings?: ImageSettings;
  isGenerateImgLoading?: boolean;
  isGenerateButtonDisabled?: boolean;
  isHistoryLoading?: boolean;
  handleClearInput?: () => void;
  handleOpenExpandImage?: () => void;
  handleSetIsLoading: (isLoading: boolean) => void;
  handleInputImageChange?: (image: File | null) => void;
  clearExtractedOutput?: () => void;
  setSelectedModel?: (model: string) => void;
  example: ImageSuiteSample;
  getErrorMessage: (error: any) => void;
  creditsNeeded?: number | null;
}

export enum SuitesApps {
  Text = 0,
  Image,
  Video,
}

export const imageSuiteAppInitStates = {
  ImageGenerator: {
    output: "",
    inputValue: "",
    selectedModel: "",
    seed: null,
    openLockSeed: true,
    selectedSize: "",
    creditsNeeded: 0,
    isLoading: false,
    type: ImageSuitApps.ImageGenerator,
    example: {
      type: 0,
      prompt: "",
      path: "",
      before: "",
      after: "",
      afterL: "",
    },
    suggestionAppData: {
      id: "",
      input: { prompt: "", imageUrl: "" },
      output: "",
      appId: "",
      appType: "",
      createdAt: "",
      settings: {
        model: "",
        dimension: "",
        seed: 0,
      },
      inputType: 0,
      outputType: 0,
    },
  },
  LogoGenerator: {
    output: "",
    inputValue: "",
    selectedModel: "",
    selectedSize: "",
    creditsNeeded: 0,
    seed: null,
    openLockSeed: true,
    isLoading: false,
    type: ImageSuitApps.LogoGenerator,
    example: {
      type: 0,
      prompt: "",
      path: "",
      before: "",
      after: "",
      afterL: "",
    },
    suggestionAppData: {
      id: "",
      input: { prompt: "", imageUrl: "" },
      output: "",
      appId: "",
      appType: "",
      createdAt: "",
      settings: {
        model: "",
        dimension: "",
        seed: 0,
      },
      inputType: 0,
      outputType: 0,
    },
  },
  IconGenerator: {
    output: "",
    inputValue: "",
    selectedModel: "",
    seed: null,
    openLockSeed: true,
    selectedSize: "",
    creditsNeeded: 0,
    isLoading: false,
    type: ImageSuitApps.IconGenerator,
    example: {
      type: 0,
      prompt: "",
      path: "",
      before: "",
      after: "",
      afterL: "",
    },
    suggestionAppData: {
      id: "",
      input: { prompt: "", imageUrl: "" },
      output: "",
      appId: "",
      appType: "",
      createdAt: "",
      settings: {
        model: "",
        dimension: "",
        seed: 0,
      },
      inputType: 0,
      outputType: 0,
    },
  },
  IllustrationGenerator: {
    output: "",
    inputValue: "",
    selectedModel: "",
    selectedSize: "",
    creditsNeeded: 0,
    seed: null,
    openLockSeed: true,
    isLoading: false,
    type: ImageSuitApps.IllustrationGenerator,
    example: {
      type: 0,
      prompt: "",
      path: "",
      before: "",
      after: "",
      afterL: "",
    },
    suggestionAppData: {
      id: "",
      input: { prompt: "", imageUrl: "" },
      output: "",
      appId: "",
      appType: "",
      createdAt: "",
      settings: {
        model: "",
        dimension: "",
        seed: 0,
      },
      inputType: 0,
      outputType: 0,
    },
  },
  BackgroundRemover: {
    output: "",
    inputValue: null,
    isLoading: false,
    selectedModel: "",
    creditsNeeded: 0,
    type: ImageSuitApps.BackGroundRemover,
    example: {
      type: 0,
      prompt: "",
      path: "",
      before: "",
      after: "",
      afterL: "",
    },
    suggestionAppData: {
      id: "",
      input: { prompt: "", imageUrl: "" },
      output: "",
      appId: "",
      appType: "",
      createdAt: "",
      settings: {
        model: "",
        dimension: "",
        seed: 0,
      },
      inputType: 0,
      outputType: 0,
    },
  },
  ImageRestore: {
    output: "",
    inputValue: null,
    isLoading: false,
    creditsNeeded: 0,
    type: ImageSuitApps.ImageRestore,
    example: {
      type: 0,
      prompt: "",
      path: "",
      before: "",
      after: "",
      afterL: "",
    },
    suggestionAppData: {
      id: "",
      input: { prompt: "", imageUrl: "" },
      output: "",
      appId: "",
      appType: "",
      createdAt: "",
      settings: {
        model: "",
        dimension: "",
        seed: 0,
      },
      inputType: 0,
      outputType: 0,
    },
  },
  MicroPeople: {
    output: "",
    inputValue: "",
    inputImageValue: null,
    selectedModel: "",
    selectedSize: "",
    creditsNeeded: 0,
    seed: null,
    openLockSeed: true,
    isLoading: false,
    type: ImageSuitApps.MicroPeople,
    example: {
      type: 0,
      prompt: "",
      path: "",
      before: "",
      after: "",
      afterL: "",
    },
    suggestionAppData: {
      id: "",
      input: { prompt: "", imageUrl: "" },
      output: "",
      appId: "",
      appType: "",
      createdAt: "",
      settings: {
        model: "",
        dimension: "",
        seed: 0,
      },
      inputType: 0,
      outputType: 0,
    },
  },
  TinyFigures: {
    output: "",
    inputValue: "",
    inputImageValue: null,
    selectedModel: "",
    selectedSize: "",
    creditsNeeded: 0,
    seed: null,
    openLockSeed: true,
    isLoading: false,
    type: ImageSuitApps.TinyFigures,
    example: {
      type: 0,
      prompt: "",
      path: "",
      before: "",
      after: "",
      afterL: "",
    },
    suggestionAppData: {
      id: "",
      input: { prompt: "", imageUrl: "" },
      output: "",
      appId: "",
      appType: "",
      createdAt: "",
      settings: {
        model: "",
        dimension: "",
        seed: 0,
      },
      inputType: 0,
      outputType: 0,
    },
  },
  ImageToImage: {
    output: "",
    inputValue: "",
    inputImageValue: null,
    selectedModel: "",
    selectedSize: "",
    creditsNeeded: 0,
    seed: null,
    openLockSeed: true,
    isLoading: false,
    type: ImageSuitApps.ImageToImage,
    example: {
      type: 0,
      prompt: "",
      path: "",
      before: "",
      after: "",
      afterL: "",
    },
    suggestionAppData: {
      id: "",
      input: { prompt: "", imageUrl: "" },
      output: "",
      appId: "",
      appType: "",
      createdAt: "",
      settings: {
        model: "",
        dimension: "",
        seed: 0,
      },
      inputType: 0,
      outputType: 0,
    },
  },
};

export const textSuiteAppInitStates = {
  translator: {
    input: "",
    output: "",
    prevOutput: "",
    isLoading: false,
  },
  humanizer: {
    input: "",
    output: "",
    prevOutput: "",
    isLoading: false,
  },
  summarizer: {
    input: "",
    output: "",
    prevOutput: "",
    isLoading: false,
  },
  paraphraser: {
    input: "",
    output: "",
    prevOutput: "",
    isLoading: false,
  },
  titlegenerator: {
    input: "",
    output: "",
    prevOutput: "",
    isLoading: false,
  },
  promptengineer: {
    input: "",
    output: "",
    prevOutput: "",
    isLoading: false,
  },
  ImageTranscription: {
    output: "",
    input: null,
    isLoading: false,
    isHistoryLoading: true,
    type: TextSuiteType.TextExtraction,
    example: {
      type: 0,
      prompt: "",
      path: "",
      before: "",
      after: "",
      afterL: "",
    },
    suggestionAppData: {
      id: "",
      input: { prompt: "", imageUrl: "" },
      output: "",
      appId: "",
      appType: "",
      createdAt: "",
      settings: {
        model: "",
        dimension: "",
        seed: 0,
      },
      inputType: 0,
      outputType: 0,
    },
  },
  ImageToPrompt: {
    output: "",
    input: null,
    isLoading: false,
    isHistoryLoading: true,
    type: TextSuiteType.ImageToPrompt,
    example: {
      type: 0,
      prompt: "",
      path: "",
      before: "",
      after: "",
      afterL: "",
    },
    suggestionAppData: {
      id: "",
      input: { prompt: "", imageUrl: "" },
      output: "",
      appId: "",
      appType: "",
      createdAt: "",
      settings: {
        model: "",
        dimension: "",
        seed: 0,
      },
      inputType: 0,
      outputType: 0,
    },
  },
};

export const TextSuiteApps = {
  Translator: "Translator",
  Humanizer: "Humanizer",
  Summarizer: "Summarizer",
  Paraphraser: "Paraphraser",
  TitleGenerator: "Title Generator",
  PromptGenerator: "Prompt Generator",
  AiDetector: "AI Detector",
  TextExtraction: "Text Extractor",
  ImageToPrompt: "Image to Prompt",
};

export const ImageSuiteApps = {
  ImageGenerator: "Text to Image",
  LogoGenerator: "Logo Generator",
  IconGenerator: "Icon Generator",
  IllustrationGenerator: "Illustration Generator",
  BackgroundRemover: "Background Remover",
  ImageRestore: "Image Restore",
  TinyFigures: "Tiny Figures",
  MicroPeople: "Micro People",
  ImageToImage: "Image to Image",
  TextToImage: "Text to Image",
};

export const VideoSuiteApps = {
  VideoGenerator: "Text to Video",
  ImageToVideo: "Image to Video",
  CustomAvatar: "Custom Avatar",
};

export enum WorkflowAppType {
  TextSuite = 1,
  ImageSuite,
  VideoSuite,
}

export interface CreditDetails {
  creditsCount: number;
  cost: number;
  checkoutUrl: string;
}

export enum SuiteType {
  Image = 0,
  Video,
}

export const WorkflowAppInputAndOutputTypes = {
  Text: "Text",
  Image: "Image",
  Video: "Video",
};

export interface TextAppHistoryItem {
  id: string;
  input: string;
  output: string;
  createdAt: string;
  appType: string;
}

export interface ImageAppHistoryItem {
  id: string;
  input: { prompt: string; imageUrl: string };
  output: string;
  appId: string;
  appType: string;
  createdAt: string;
  settings: {
    model: string;
    dimension: string;
    seed: number | null;
  };
  inputType: number;
  outputType: number;
}

export const SuiteApps = {
  Text: "Text",
  Image: "Image",
  Video: "Video",
};

export enum WorkflowType {
  System = 1,
  User,
}

// Helper function to check if a string is a GUID or a number
const isId = (str: string) => {
  // Check for GUID (UUID v4)
  const guidRegex =
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  // Check for number
  const numberRegex = /^\d+$/;
  return guidRegex.test(str) || numberRegex.test(str);
};

export const getPathNameParts = (pathname: string) => {
  // Split and filter empty
  const parts = pathname.split("/").filter(Boolean);
  // Filter out ids
  const filtered = parts.filter((part) => !isId(part));
  // Return 'Expertex' if root path
  if (filtered.length === 0) return "Expertex";
  // Return first and second if available
  return filtered
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" | ");
};

export const metaTags = [
  {
    name: "description",
    content:
      "Expertex AI solution helps content creators and businesses create, monitor, and automate high-quality digital content.",
  },
  {
    name: "keywords",
    content:
      "Expertex, Expertex.ai, AI Playground, Conversational AI, AI Video Generator, AI Chatbot, AI Assistant, Text-to-Video,Image-to-Video, Image Generation, Text-to-Image, AI Personas, Custom AI Agents,AI Tools, AI Models, AI API, Prompt Engineering, Prompt Testing, Prompt Library, Multi-agent AI, Generative AI, AI Content Creation,GPT, Claude, Mistral, DeepSeek, Meta, OpenAI, Anthropic, HuggingFace, NVIDIA, Google, AI Model Comparison, LLM Comparison,Fine-tuning LLMs, Natural Language Processing, AI Inference, AI Deployment, AI Integration, AI for Developers, AI Use Cases,Best AI Tools, Productivity AI, LLMs, AI Features Matrix, Unified AI Interface, AI Output Evaluation",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1.0",
  },

  // Open Graph
  {
    property: "og:title",
    content: "Expertex",
  },
  {
    property: "og:description",
    content:
      "Expertex AI solution helps content creators and businesses create, monitor, and automate high-quality digital content.",
  },
  {
    property: "og:image",
    content:
      "https://expertex.ai/static/media/logo-dark.484fd2fed07e05663cff.svg", // thumbnail image that will be shown in social media
  },
  {
    property: "og:url",
    content: window.location.href,
  },
  {
    property: "og:type",
    content: "website",
  },

  // Twitter Card
  {
    name: "twitter:card",
    content: "summary_large_image",
  },
  {
    name: "twitter:title",
    content: "ExpertexAI",
  },
  {
    name: "twitter:description",
    content:
      "Expertex AI solution helps content creators and businesses create, monitor, and automate high-quality digital content.",
  },
  {
    name: "twitter:image",
    content:
      "https://expertex.ai/static/media/logo-dark.484fd2fed07e05663cff.svg",
  },

  // SEO control
  { name: "robots", content: "index, follow" },
  { name: "author", content: "ExpertexAI Team" },
];

export async function checkInternet() {
  if (!navigator.onLine) return false;
  try {
    const res = await fetch("https://www.google.com/favicon.ico", {
      method: "HEAD",
      mode: "no-cors",
    }); // Create a simple health-check route
    return true;
  } catch (error) {
    return false;
  }
}

export const getTruncatedFilename = (imageValue:File) => {
    const name = (imageValue instanceof File && imageValue?.name) || "";
    const dotIndex = name.lastIndexOf(".");
    if (dotIndex === -1) return name; // No extension

    const base = name.slice(0, dotIndex);
    const ext = name.slice(dotIndex);

    return base.length > 10 ? base.slice(0, 8) + "..." + ext : name;
  };

export enum ShareType{
  Chat = 1,
  App,
  Workflow,
}

export const getFileFromImage = async (
  image: File | string | null
): Promise<File | null> => {
  if (!image) return null;
  if (image instanceof File) return image;

  const response = await fetch(image);
  if (!response.ok) return null;
  const blob = await response.blob();
  const fileName = "image." + (blob.type.split("/")[1] || "png");
  return new File([blob], fileName, { type: blob.type });
};
export enum SoundEffectCategory {
    AtmospheresAndDrones = 0,
    HumanAndFoley,
    ImpactsAndHits,
    MusicalElements,
    NatureAndCreatures,
    UIAndMiscellaneous
}